'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryMenu = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

var _reactRedux = require('react-redux');

var _nuiIntl = require('@concur/nui-intl');

var _nuiWidgets = require('@concur/nui-widgets');

var _utils = require('../utils');

var _analytics = require('../constants/analytics');

var _listingsModule = require('../listings/listingsModule');

var ListingsActions = _interopRequireWildcard(_listingsModule);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultCategory = {
  slug: 'all',
  code: 'ALL_APPS',
  description: 'All Apps'
};

var ACTION_POP = 'POP';

var CategoryMenu = function (_React$Component) {
  _inherits(CategoryMenu, _React$Component);

  function CategoryMenu(props) {
    _classCallCheck(this, CategoryMenu);

    var _this = _possibleConstructorReturn(this, (CategoryMenu.__proto__ || Object.getPrototypeOf(CategoryMenu)).call(this, props));

    _this.handleLinkClick = _this.handleLinkClick.bind(_this);
    return _this;
  }

  _createClass(CategoryMenu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.backListenerCallback = function (location) {
        if (location.action === ACTION_POP) {
          var pathname = _this2.props.location.pathname;
          var slug = pathname.substr(pathname.lastIndexOf('/') + 1);
          // not logged in uses app-center, logged in uses appcenter
          if (slug === 'app-center' || slug === 'appcenter') {
            slug = 'all';
          }
          _this2.props.categories.map(function (category) {
            if (category.slug == slug) {
              _this2.props.setCategory(category);
              return;
            }
            category.subcategories.map(function (subcategory) {
              if (subcategory.slug == slug) {
                _this2.props.setCategory(subcategory);
                return;
              }
            });
          });
        }
      };
      this.backListener = _reactRouter.browserHistory.listen(this.backListenerCallback);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Unbind listener
      this.backListener();
    }
  }, {
    key: 'handleLinkClick',
    value: function handleLinkClick(category) {
      var _props = this.props,
          router = _props.router,
          location = _props.location,
          setAndFilterByCategory = _props.setAndFilterByCategory,
          trackCategoryLinkClick = _props.trackCategoryLinkClick,
          companyUUID = _props.companyUUID;


      var pathname = (0, _utils.getAppCenterPathName)(location.pathname);
      var categoryRoute = pathname + '/category/' + category.slug;
      var context = router.location.pathname === pathname ? _analytics.CONTEXTS.HOME : _analytics.CONTEXTS.LISTING_DETAILS;

      setAndFilterByCategory(category);
      router.push(categoryRoute);

      // track clicks
      if (typeof caLogger !== 'undefined') {
        caLogger.track(_analytics.EVENTS.CLICK, {
          context: context,
          type: _analytics.TYPES.LINK,
          value: _analytics.VALUES.CATEGORY,
          category: category.description,
          domain: window.location.hostname
        });
      }

      trackCategoryLinkClick({
        elementPath: [_analytics.categoryDropdown, category.slug],
        dimensions: {
          category: category.slug,
          companyUUID: companyUUID
        }
      });
    }
  }, {
    key: 'renderCategories',
    value: function renderCategories() {
      var _this3 = this;

      var categories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var isChildren = arguments[1];
      var _props$category = this.props.category,
          currentCategory = _props$category === undefined ? defaultCategory : _props$category;


      return categories.reduce(function (items, category) {
        items.push(_react2.default.createElement(
          _nuiWidgets.MenuItem,
          {
            key: category.code,
            eventKey: category,
            active: currentCategory.code === category.code,
            className: isChildren && 'subcategories'
          },
          category.description
        ));

        if (category.subcategories) {
          return items.concat(_this3.renderCategories(category.subcategories, true));
        }

        return items;
      }, []);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          formatter = _props2.formatter,
          categories = _props2.categories,
          category = _props2.category,
          display = _props2.display;


      var label = formatter.formattedMessage({ id: 'Category' }) + ':';

      return display ? _react2.default.createElement(
        _nuiWidgets.ButtonToolbar,
        {
          muted: true,
          style: { paddingTop: '4px', paddingBottom: '6px' }
        },
        _react2.default.createElement(
          _nuiWidgets.ButtonDropdown,
          {
            id: 'categoryDropdown',
            type: 'link',
            textLabel: label,
            title: category === undefined ? categories[0].description : category.description,
            onSelect: this.handleLinkClick },
          this.renderCategories(categories)
        )
      ) : _react2.default.createElement('br', null);
    }
  }]);

  return CategoryMenu;
}(_react2.default.Component);

CategoryMenu.propTypes = {
  setAndFilterByCategory: _propTypes2.default.func.isRequired,
  categories: _propTypes2.default.arrayOf(_propTypes2.default.object),
  router: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
  location: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  display: _propTypes2.default.bool,
  category: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  trackCategoryLinkClick: _propTypes2.default.func,
  companyUUID: _propTypes2.default.string,
  listingName: _propTypes2.default.string
};

function mapStateToProps(state) {
  return {};
}

var mapDispatchToProps = {
  setCategory: ListingsActions.setCategory
};

exports.CategoryMenu = CategoryMenu;
exports.default = (0, _nuiIntl.withFormatter)((0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CategoryMenu)));


//////////////////
// WEBPACK FOOTER
// ./lib/shared/CategoryMenu.js
// module id = 566
// module chunks = 0